import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';
import storage from '@/plugins/storage.js'

import header from './modules/header'
import search from './modules/search'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navList: [], // 首页快捷导航
    cartNum: storage.getItem('cartNum') || 0,
    logoImg: require('@/assets/images/logo2.png'),
    hotWordsList: storage.getItem('hotWordsList'),
    category: JSON.parse(localStorage.getItem('category'))
  },
  getters: {
    token: state => state.user.token,
    userId: state => state.user.userId,
    nickName: state => state.user.nickName,
    avatar: state => state.user.avatar,
    allCity: state => state.search.allCity,
    orderAllCity: state => state.search.orderAllCity,
    cityName: state => state.search.cityName,
    cityCode: state => state.search.cityCode,
    region: state => state.search.region,
    point: state => state.search.point,
    dateRange: state => state.search.dateRange,
    showLoginDialog: state=> state.header.showLoginDialog,
    notice: state=> state.header.notice,
    unReadNotice: state => state.header.unReadNotice,
  },
  actions,
  mutations,
  modules: {
    header,
    search
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js